import axios from 'axios';

/*
*  This file contains all axios calls related to unlayer landing page goal operations
*/

export const loadLandingPage = async (landingPageId) => {
    const { data: { id, title } } = await axios.get(`/app/unlayerLandingPageFunnel/templateGroup/${landingPageId}`);

    return { id, title };
};

export const loadLandingPages = async () => {
    const { data } = await axios.get('/app/unlayerLandingPageFunnel/loadTemplateGroups');

    return data;
};

export const loadLandingPageForms = async (templateGroupId) => {
    const { data } = await axios.get(`/app/unlayerLandingPageFunnel/loadForms/${templateGroupId}`);

    return data;
};

export const searchLandingPages = async (filter) => {
    const { data } = await axios.get(`/app/unlayerLandingPageFunnel/templateGroups/${filter}`);

    return data;
};
